// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid_grid__1W2I1","minWidth":"grid_minWidth__o__ic","relat":"grid_relat__BA5P9","title":"grid_title__3ugPY","hover":"grid_hover__569s8"};